import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from 'react-bootstrap';

const DashboardButton = ({ title, description, faIcon, fullHeight = true, compact = false, className = '' }) => {
  const iconSize = compact ? 28 : 40;
  const titleSize = compact ? 13 : 15;
  const descSize = compact ? 9 : 10;
  const padding = compact ? 'pt-3 pb-3' : 'pt-4';
  return (
    <Card className={`text-center ${padding} ${!compact && fullHeight && 'h-100'} ${className}`.trim()}>
      <FontAwesomeIcon icon={faIcon} style={{ fontSize: iconSize }} />
      <Card.Body className={compact ? 'py-3' : undefined}>
        <Card.Title style={{ fontSize: titleSize }}>{title}</Card.Title>
        <Card.Text style={{ fontSize: descSize }}>{description}</Card.Text>
      </Card.Body>
    </Card>
  );
};

export default DashboardButton;
